import { Component, Input, ViewChild, OnInit } from '@angular/core';
import { QuillEditorComponent as NgxQuillEditor } from 'ngx-quill';

@Component({
  selector: 'antim-autoware-editor',
  standalone: false,
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.scss']
})
export class EditorComponent implements OnInit {
  editorModules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      ['blockquote', 'code-block'],
      // [{ header: 1 }, { header: 2 }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ script: 'sub' }, { script: 'super' }],
      [{ indent: '-1' }, { indent: '+1' }],
      [{ direction: 'rtl' }],
      // [{ size: ['small', false, 'large', 'huge'] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{
        color: ['#000000', '#444444', '#666666', '#999999', '#cccccc', '#eeeeee', '#ffffff',
          '#ff0000', '#ff9900', '#ffff00', '#00ff00', '#00ffff', '#0000ff', '#9900ff',
          '#ff00ff', '#f4cccc', '#fce5cd', '#fff2cc', '#d9ead3', '#d0e0e3', '#cfe2f3',
          '#d9d2e9', '#ead1dc', '#ea9999', '#f9cb9c', '#ffe599', '#b6d7a8', '#a2c4c9',
          '#9fc5e8', '#b4a7d6', '#d5a6bd', '#e06666', '#f6b26b', '#ffd966', '#93c47d',
          '#76a5af', '#6fa8dc', '#8e7cc3', '#c27ba0', '#cc0000', '#e69138', '#f1c232',
          '#6aa84f', '#45818e', '#3d85c6', '#674ea7', '#a64d79', '#990000', '#b45f06',
          '#bf9000', '#38761d', '#134f5c', '#0b5394', '#351c75', '#741b47', '#FF6633']
      }, {
        background: ['','#000000', '#444444', '#666666', '#999999', '#cccccc', '#eeeeee', '#ffffff',
          '#ff0000', '#ff9900', '#ffff00', '#00ff00', '#00ffff', '#0000ff', '#9900ff',
          '#ff00ff', '#f4cccc', '#fce5cd', '#fff2cc', '#d9ead3', '#d0e0e3', '#cfe2f3',
          '#d9d2e9', '#ead1dc', '#ea9999', '#f9cb9c', '#ffe599', '#b6d7a8', '#a2c4c9',
          '#9fc5e8', '#b4a7d6', '#d5a6bd', '#e06666', '#f6b26b', '#ffd966', '#93c47d',
          '#76a5af', '#6fa8dc', '#8e7cc3', '#c27ba0', '#cc0000', '#e69138', '#f1c232',
          '#6aa84f', '#45818e', '#3d85c6', '#674ea7', '#a64d79', '#990000', '#b45f06',
          '#bf9000', '#38761d', '#134f5c', '#0b5394', '#351c75', '#741b47', '#FF6633']
      }],
      // [{ font: [] }],
      [{ align: [] }],
      ['clean'],
      ['link']
    ]
  };

  @Input() isRequired = false;
  @Input() labelHide = false;
  @Input() labelValue = '';
  @Input() errorMessage = '';
  @Input() disabled = false;
  @Input() id = '';
  @Input() placeholder = '';
  @Input() control: any;
  @Input() inputType:
    | 'primary'
    | 'primaryWithoutBorder'
    | 'secondary'
    | 'secondaryWithoutBorder'
    | 'warning'
    | 'warningWithoutBorder'
    | 'success'
    | 'successWithoutBorder'
    | 'error'
    | 'errorWithoutBorder' = 'primary';

  @ViewChild('quillEditor') quillEditorComponent!: NgxQuillEditor;
  showHtml = false;
  htmlContent = '';

  ngOnInit() {
  }

  onEditorCreated(quill: any) {
    quill.format('color', '#262626');
    const toolbar = quill.getModule('toolbar');
    toolbar.addHandler('color', (value: string) => {
      quill.format('color', value ? value : '#262626');
    });
  }

  onEditorChanged(event: any) {
    const html = event.html;
    if (!this.showHtml && html !== this.control.value) {
      this.control.setValue(html, { emitEvent: false });
    }
  }

  toggleHtmlView() {
    const quill = this.quillEditorComponent.quillEditor;
    const editorElem = quill.root;
    if (!this.showHtml) {
      this.htmlContent = editorElem.innerHTML;
    } else {
      editorElem.innerHTML = this.htmlContent;
      this.control.setValue(this.htmlContent, { emitEvent: false });
    }
    this.showHtml = !this.showHtml;
  }

  onHtmlInputChange(event: any) {
    this.htmlContent = event.target.value;
    this.control.setValue(this.htmlContent, { emitEvent: false });
  }
}
